import React, { useState } from 'react';
import { requestRegistrationEmail } from '../api/AuthAPI';
import { getUserMessage, logApiError, parseApiError } from '../api/apiError';

const RequestRegistrationForm: React.FC = () => {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [traceId, setTraceId] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            await requestRegistrationEmail(email);
            setSubmitted(true);
        } catch (err) {
            logApiError(err);
            setError(getUserMessage(err));
            setTraceId(parseApiError(err)?.traceId ?? null);
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className="auth-card">
                <h2>Check Your Email</h2>
                <p className="subtitle">
                    We've sent a registration link to <strong>{email}</strong>. Please check your inbox.
                </p>
            </div>
        );
    }

    return (
        <div className="auth-card">
            <h2>Create Account</h2>
            <p className="subtitle">Enter your email to get started</p>
            <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-group">
                    <label htmlFor="reqEmail">Email Address</label>
                    <input
                        type="email"
                        id="reqEmail"
                        name="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? 'Sending...' : 'Send Registration Link'}
                </button>
                {error && (
                    <p className="error-message">
                        {error}
                        {traceId && <span className="error-trace">Reference: {traceId}</span>}
                    </p>
                )}
            </form>
        </div>
    );
};

export default RequestRegistrationForm;